import * as types from "../types/failedOrders"

const initialState = []

const failedOrdersReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_FAILED_ORDER:
      return [action.failedOrder, ...state]
    case types.REMOVE_FAILED_ORDER:
      return state.filter((_, failedOrderIndex) =>
        failedOrderIndex !== action.failedOrderIndex
      )
    default:
      return state
  }
}

export default failedOrdersReducer